<template>
    <div class="flex w-full flex-col p-5 gap-1 max-w-xl">
        <template v-if="readOnly">
            <table>
                <tr>
                    <th class="p-2 text-right align-top">
                        <app-label :label="$t('commons.siret') + ' : '"></app-label>
                    </th>
                    <td class="p-2">
                        <div class="flex flex-col">
                            {{ organization.siret }}
                        </div>
                    </td>
                </tr>
                <tr>
                    <th class="p-2 text-right align-top">
                        <app-label :label="$t('commons.address') + ' : '"></app-label>
                    </th>
                    <td class="p-2">
                        <div class="flex flex-col">
                            {{ organization.address }}
                            <br />
                            {{ organization.postalCode }} {{ organization.city }}
                        </div>
                    </td>
                </tr>
            </table>
        </template>
        <template v-else>
            <div class="flex gap-2">
                <app-input-text
                    :label="$t('commons.name') + ' : '"
                    v-model="organization.name"
                    @blur="save"
                    class="w-full"
                ></app-input-text>
            </div>
            <div class="flex gap-2">
                <app-input-text
                    :label="$t('commons.siret') + ' : '"
                    v-model="organization.siret"
                    @blur="save"
                    class="w-full"
                ></app-input-text>
            </div>
            <div class="flex gap-2">
                <app-textarea
                    :label="$t('commons.address') + ' : '"
                    v-model="organization.address"
                    @blur="save"
                    class="w-full"
                ></app-textarea>
            </div>
            <div class="flex gap-2">
                <app-input-text
                    :label="$t('commons.postalCode') + ' : '"
                    v-model="organization.postalCode"
                    @blur="save"
                    class="w-full"
                ></app-input-text>
            </div>
            <div class="flex gap-2">
                <app-input-text
                    :label="$t('commons.city') + ' : '"
                    v-model="organization.city"
                    @blur="save"
                    class="w-full"
                ></app-input-text>
            </div>
        </template>
    </div>
</template>

<script>
import AppInputText from '@/components/appInputText/AppInputText.vue';
import { getOrganization, updateOrganization } from '@/features/organizations/organizations.service';
import AppLabel from '@/components/appLabel/AppLabel.vue';
import AppTextarea from '@/components/app-textarea/AppTextarea.vue';
import { getLoggedUser } from '@/features/tokens/token.service';
import { updateBreadCrumbs } from '@/state/state';

export default {
    components: { AppTextarea, AppInputText, AppLabel },
    created() {
        this.init();
    },
    watch: {
        $route() {
            this.init();
        },
    },
    methods: {
        async init() {
            this.organization = await getOrganization(this.$route.params.organizationId);
            updateBreadCrumbs({ organizationName: this.organization.name });
            const token = getLoggedUser();
            const isRoot = token && token.roles.includes('root');
            const isOwner = this.organization.ownerId === token.id;
            this.readOnly = !isRoot && !isOwner;
        },
        async save() {
            const owner = this.organization.owner;
            this.organization = await updateOrganization({
                id: this.organization.id,
                name: this.organization.name,
                address: this.organization.address,
                postalCode: this.organization.postalCode,
                city: this.organization.city,
                phone: this.organization.phone,
                siret: this.organization.siret,
                email: this.organization.email,
            });
            updateBreadCrumbs({ organizationName: this.organization.name });
            this.organization.owner = owner;
        },
    },
    data() {
        return {
            readOnly: true,
            organization: {},
        };
    },
};
</script>
